import { FeatureBlock, FeatureComparison } from "../_copy-template"
import ClientCommunication from "~images/pages/comparison/features/client-communication.png"

export function getClientCommunicationCopy(
    competitor: FeatureBlock,
    nameOverride?: string
): FeatureComparison {
    return {
        name: nameOverride || "Client Communication",
        image: ClientCommunication,
        chckup: {
            showCheck: true,
            description:
                "With Chckvet, you can send automated emails and text messages to your patients to remind them of their appointments, collect client feedback through reviews, and send reminders to schedule their next appointment.",
        },
        competitor,
        href: "/features/messaging",
    }
}
